import { Table } from "@/types/globalTypes";
import TableCard from "./TableCard";
import { Skeleton } from "../ui/skeleton";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { useTranslation } from "react-i18next";
type TablesListProps = {
  tables: Table[];
  floorNumber: number | string;
  floorId: number | string;
  isLoading: boolean;
  setNeedRefetch: React.Dispatch<React.SetStateAction<boolean>>
};

function TablesList({ tables, isLoading, floorNumber,setNeedRefetch, floorId }: TablesListProps) {
 const { t } = useTranslation();
  if (isLoading)
    return (
      <>
        <div className="xs:flex xs:flex-wrap xs:gap-5 xs:justify-start xs:items-start grid grid-cols-2 gap-5 ">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton
              key={i}
              className="aspect-square h-[260px] w-full dark:bg-slate-600 dark:bg-opacity-35 xs:w-[160px]"
            />
          ))}
        </div>
      </>
    );

  if (!tables?.length)
    return (
      <>
        <Alert className="border-none bg-skyblue text-sidebar dark:border-none dark:bg-skyblue dark:text-sidebar">
          <AlertTitle className="text-center text-xl">
          {t("tableList.noTablesFound")}
          </AlertTitle>
          <AlertDescription className="my-5 text-center font-semibold">
          {t("tableList.emptyMessage")}
          </AlertDescription>
        </Alert>
      </>
    );

  return (
    // <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 sm:gap-5 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7">
    <div className="xs:flex xs:flex-wrap xs:gap-2 xs:justify-start xs:items-start grid grid-cols-2 gap-2 ">
      {tables.map((table, index) => (
        <TableCard table={table} floorNumber={floorNumber} key={index}  setNeedRefetch={setNeedRefetch} floorId={floorId}/>
      ))}
    </div>
  );
}

export default TablesList;
